"use strict";
var EmptyObservable_1 = require('./EmptyObservable');
exports.empty = EmptyObservable_1.EmptyObservable.create;
//# sourceMappingURL=empty.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/observable/empty.js
// module id = vvwv
// module chunks = 0